import React from 'react';

function CourseGrid({ courses, isPurchased = false, bundleMode = false, selectedForBundle = [], onToggleSelection = null, purchasedCourseIds = [], isFeatured = false }) {
  const CourseCard = require('./CourseCard').default;
  
  if (!courses || courses.length === 0) {
    return (
      <div className="text-center py-20">
        <div className="w-20 h-20 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
          <i className="fas fa-graduation-cap text-gray-400 text-3xl"></i>
        </div>
        <h3 className="text-2xl font-bold text-gray-800 mb-2">لا توجد دورات</h3>
        <p className="text-gray-600">لم يتم العثور على أي دورات في الوقت الحالي</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
      {courses.map((course, index) => (
        <div 
          key={course.id}
          className={isFeatured && index === 3 ? 'lg:hidden' : ''}
        >
          <CourseCard 
            course={course} 
            isPurchased={isPurchased || purchasedCourseIds.includes(course.id)}
            bundleMode={bundleMode}
            isSelected={bundleMode && selectedForBundle.some(c => c.id === course.id)}
            onToggleSelection={onToggleSelection}
          />
        </div>
      ))}
    </div>
  );
}

export default CourseGrid;
